import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { Space } from "types/generated";
import { hasAdminAccess } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

type CloudIntegration = {
  spaceDetails: Pick<Space, "id" | "accessLevel">;
};

const useCanManageCloudIntegration = (): ((integration: CloudIntegration) => boolean) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (integration: CloudIntegration) => {
      if (viewer.admin) {
        return true;
      }

      return hasAdminAccess(viewer, integration.spaceDetails.id);
    },
    [viewer]
  );
};

export default useCanManageCloudIntegration;
